enum RecognitionCategory {
    TeamPlayer = "TeamPlayer",
    Excellence = "Excellence",
    Positivity = "Positivity",
    Leadership = "Leadership",
    ShowingUp = "ShowingUp"
}

export default RecognitionCategory;